import React, { Component } from "react";


import { Icon } from "@iconify/react";

import whatsapp from '@iconify/icons-mdi/whatsapp';

import contactService from "../services/contactService";


class WhatsappButton extends Component {

    constructor(props) {
        super(props);

        this.state = {
            whatsapp: {
                message: "",
                number: "",
                url: ""
            }

        }

    }

    async componentDidMount() {
        this.setState({ whatsapp: await this.getBusinessAccount() });
    }

    async getBusinessAccount() {
        try {
            const retorno = await contactService.getBusinessAccount();

            return {
                message: retorno.message,
                number: retorno.number,
                url: {
                    br: "https://api.whatsapp.com/send?phone=" + retorno.number.replace(/\D/g, '') + "&text=" + encodeURI(retorno.message["br"]),
                    es: "https://api.whatsapp.com/send?phone=" + retorno.number.replace(/\D/g, '') + "&text=" + encodeURI(retorno.message["es"]),
                    en: "https://api.whatsapp.com/send?phone=" + retorno.number.replace(/\D/g, '') + "&text=" + encodeURI(retorno.message["en"])
                }
            };
        } catch {
            return {
                message: "",
                number: "",
                url: ""
            };
        }

    }

    componentWillUnmount() {

    }


    render() {
        let { language } = this.props;
        language = language ? language : this.currentLanguage;
        let urlWhatsapp = this.state.whatsapp.url? this.state.whatsapp.url[language] : "";

        return (
            <>
                {(urlWhatsapp) && <a   translate="no" href={urlWhatsapp} target="_blank" rel="noopener noreferrer">
                    <div   translate="no" id="whatsappButton" className="whatsapp-button">
                        <Icon id="whatsappButtonIcon" icon={whatsapp} className="icon" width="33" height="33" />
                    </div>
                </a>}
            </>
        );
    }
}

export default WhatsappButton;